/** @type {import('tailwindcss').Config} */
const flowbite = require('flowbite-react/tailwind');

module.exports = {
  content: [
    './app/**/*.{js,ts,jsx,tsx,mdx}',
    './pages/**/*.{js,ts,jsx,tsx,mdx}',
    './components/**/*.{js,ts,jsx,tsx,mdx}',
    flowbite.content(),
  ],
  theme: {
    screens: {
      smOnly: { min: '0px', max: '639px' },
      mdOnly: { min: '768px', max: '1279px' },
      xs: { min: '420px' },
      sm: { min: '640px' },
      md: { min: '768px' },
      notLg: { max: '1279px' },
      lg: { min: '1280px' },
    },
    extend: {
      gridTemplateColumns: {
        fluid: 'repeat(auto-fit, minmax(15rem, 1fr))',
      },
      fontFamily: {
        montserrat: ['var(--font-montserrat)'],
        inter: ['var(--font-inter)'],
      },
      colors: {
        glPrimary: '#15803D',
        glPrimaryHover: '#166534',
        glSecondary: '#16A34A',
        glSecondaryHover: '#15803D',
        glDisabled: '#E4E4E7',
        glDisabledHover: '#E4E4E7',
        glWarning: '#FFF1EB',
        glWarningHover: '#FFE1D1',
        glError: '#FEE2E2',
        glErrorHover: '#FECACA',
      },
      backgroundImage: {},
    },
  },
  plugins: [flowbite.plugin()],
};
